<script setup lang="ts">
import type {ErrorPreview} from '../../types/previews.ts';

const {err} = defineProps<{err: ErrorPreview}>();
</script>

<template>
  <div>
    Error Loading '{{ err.path }}': {{ err.message }}
  </div>
</template>
